
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Moderne, grosse Flugzeuge verfügen über eine sehr gute Belüftung und
  Luftfilterung. Das Risiko während eines Fluges geht vor allem von den Menschen
  aus, die direkt nebenan sitzen. Diese Gefahr kann durch das Tragen von Masken
  und möglichst wenig Kommunikation mit dem Sitznachbarn reduziert werden. Von
  Vorteil ist auch, wenn die mittlere Sitzreihe leer bleibt. Beim Ein- und
  Aussteigen wird in der Regel weniger belüftet, weshalb das Tragen einer Maske
  dann besonders wichtig ist.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;